const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      const installingWorker = registration.installing;
      if (installingWorker == null) return;

      installingWorker.onstatechange = () => {
        if (installingWorker.state === 'installed') {
          const hasController = navigator.serviceWorker.controller;

          if (hasController && config?.onUpdate) {
            config.onUpdate(registration);
          }

          if (!hasController && config?.onSuccess) {
            config.onSuccess(registration);
          }
        }
      };

      // Correção aqui: não reatribuir diretamente a propriedade
      Object.assign(registration, {
        onupdatefound: () => {
          const worker = registration.installing;
          if (worker) {
            worker.onstatechange = installingWorker.onstatechange;
          }
        },
      });
    })
    .catch((error) => error);
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      const isInvalid =
        response.status === 404 ||
        (contentType && !contentType.includes('javascript'));

      if (isInvalid) {
        navigator.serviceWorker.ready.then((registration) =>
          registration.unregister().then(() => {
            window.location.reload();
          }),
        );
        return;
      }

      registerValidSW(swUrl, config);
    })
    .catch(() => {});
}

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {});
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => error);
  }
}
